import { render, staticRenderFns } from "./dashboardBanners.vue?vue&type=template&id=4502aac6"
import script from "./dashboardBanners.vue?vue&type=script&lang=js"
export * from "./dashboardBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports